// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.bookmark-url {
  margin-top: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 1em;
  margin-right: 1em;
}

.bookmark-url a {
  color: gray;
  font-size: 0.85rem;
}

.custom-card {
  background-color: white;
  align-items: center;
  border-radius: 12px !important;
  flex-direction: row !important;
  border-style: none;
}

.card-title {
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}

.card-text {
  overflow: hidden;
  white-space: pre-wrap;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}

@media only screen and (max-width: 768px) {
  .card-body {
    padding: 0.5em 1.2em;
  }
  .card-body .card-text {
    margin: 0;
  }
  .card img {
    width: 50%;
  }
}
@media only screen and (max-width: 1200px) {
  .card img {
    width: 40%;
  }
}
.red-dot {
  height: 10px;
  width: 10px;
  background-color: rgb(251, 90, 90);
  border-radius: 50%;
  display: inline-block;
}

.green-dot {
  height: 10px;
  width: 10px;
  background-color: rgb(63, 230, 66);
  border-radius: 50%;
  display: inline-block;
}

.dots:after {
  content: "⠇";
  font-size: 20px;
}

.custom-dropdown-btn {
  padding: 0 !important;
  margin: 0 !important;
}

.note-link {
  padding-top: 5px;
  font-size: 12px;
  vertical-align: middle;
  cursor: pointer;
}

.note-link-not {
  opacity: 0.5;
  font-size: 12px;
  padding-top: 5px;
  vertical-align: middle;
  cursor: pointer;
}

.available-text {
  opacity: 0.5;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/Board/BookmarksPanel/Bookmark/Bookmark.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AAEF;;AAAA;EACE,WAAA;EACA,kBAAA;AAGF;;AADA;EACE,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,8BAAA;EACA,kBAAA;AAIF;;AAFA;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA,EAAA,4BAAA;EACA,4BAAA;AAKF;;AAFA;EACE,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA,EAAA,4BAAA;EACA,4BAAA;AAKF;;AAMA;EACE;IACE,oBAAA;EAHF;EAKA;IACE,SAAA;EAHF;EAKA;IACE,UAAA;EAHF;AACF;AAQA;EACE;IACE,UAAA;EANF;AACF;AASA;EACE,YAAA;EACA,WAAA;EACA,kCAAA;EACA,kBAAA;EACA,qBAAA;AAPF;;AAUA;EACE,YAAA;EACA,WAAA;EACA,kCAAA;EACA,kBAAA;EACA,qBAAA;AAPF;;AAUA;EACE,YAAA;EACA,eAAA;AAPF;;AAUA;EACE,qBAAA;EACA,oBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;AAPF;;AAUA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;AAPF;;AAUA;EACE,YAAA;EACA,eAAA;AAPF","sourcesContent":[".bookmark-url {\n  margin-top: 0.5rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-left: 1em;\n  margin-right: 1em;\n}\n.bookmark-url a {\n  color: gray;\n  font-size: 0.85rem;\n}\n.custom-card {\n  background-color: white;\n  align-items: center;\n  border-radius: 12px !important;\n  flex-direction: row !important;\n  border-style: none;\n}\n.card-title {\n  font-weight: 400;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2; /* number of lines to show */\n  -webkit-box-orient: vertical;\n}\n\n.card-text {\n  overflow: hidden;\n  white-space: pre-wrap;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2; /* number of lines to show */\n  -webkit-box-orient: vertical;\n}\n\n// .dropdown .btn {\n  // border-radius: 5px !important;\n  // background-color: rgb(228, 228, 228);\n  // color: rgb(41, 41, 41);\n// }\n\n// Small to Tablet\n\n@media only screen and (max-width: 768px) {\n  .card-body {\n    padding: 0.5em 1.2em;\n  }\n  .card-body .card-text {\n    margin: 0;\n  }\n  .card img {\n    width: 50%;\n  }\n}\n\n// Tablet to Desktop\n\n@media only screen and (max-width: 1200px) {\n  .card img {\n    width: 40%;\n  }\n}\n\n.red-dot {\n  height: 10px;\n  width: 10px;\n  background-color: rgb(251, 90, 90);\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.green-dot {\n  height: 10px;\n  width: 10px;\n  background-color: rgb(63, 230, 66);\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.dots:after {\n  content: '\\2807';\n  font-size: 20px;\n}\n\n.custom-dropdown-btn{\n  padding: 0!important;\n  margin: 0!important;\n}\n\n.note-link{\n  padding-top: 5px;\n  font-size: 12px;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n.note-link-not{\n  opacity: 0.5;\n  font-size: 12px;\n  padding-top: 5px;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n.available-text{\n  opacity: 0.5;\n  font-size: 12px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
